import { render } from "./LuxuryRecycle.vue?vue&type=template&id=a520bd36&scoped=true"
import script from "./LuxuryRecycle.vue?vue&type=script&lang=js"
export * from "./LuxuryRecycle.vue?vue&type=script&lang=js"

import "./LuxuryRecycle.vue?vue&type=style&index=0&id=a520bd36&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a520bd36"]])

export default __exports__